export default "__VITE_ASSET__240bb026__"